import { defineComponent as _defineComponent } from 'vue'
import type { TvstSpotlightModuleFragment } from '@/features/onboarded-home/types';
import type { ModuleTitleFieldsFragment } from '@/features/onboarded-home/graphql/queries/GetHomeModules.query';

import SpotlightModuleWithHorizontalScroll from '@/features/onboarded-home/components/modules/spotlights/SpotlightModuleWithHorizontalScroll.vue';
import TitleCardShowEpisode from '@/components/list/title-card/TitleCardShowEpisode.vue';

import { useListActions } from '@/helpers/composables/useListActions';
import { useFilterStore, useUserStore } from '@/helpers/composables/useStores';

import { CollectionType } from '@/enums/collection-type';
import { toGQLMonetizationType } from '@/helpers/graphql-model-helper';
import { calculateUrl } from '@/helpers/state-helper';
import { TabType } from '@/interfaces/inner-tabs';
import { TitleObjectType } from '@/interfaces/titles';

import { useRouter } from 'vue-router/composables';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import { useHomeModuleTracking } from '@/features/onboarded-home/tracking';

import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TvstSpotlightModule',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null
  },
  setup(__props: any) {

const props = __props as {
	moduleData: TvstSpotlightModuleFragment;
	globalPosition: number;
	localPosition?: number;
};



const router = useRouter();
const { settings } = useUserStore();
const { currentFilters } = useFilterStore();
const { setInSeenlist } = useListActions();
const saving = ref(false);

const showAllUrl = computed(() =>
	calculateUrl(
		router,
		undefined,
		CollectionType.MY_LISTS,
		{ inner_tab: TabType.WATCHLIST, content_types: [TitleObjectType.SHOW] },
		{}
	)
);

// This is probably 100% broken
async function handleMarkAsSeen(episode: ModuleTitleFieldsFragment) {
	if (episode.__typename === 'Show' && episode.watchNextEpisode) {
		const titleToMarkAsSeen = episode.watchNextEpisode;
		const isTitleInSeenlist = false;

		try {
			saving.value = true;

			const watchNowPackages =
				currentFilters.value.providers?.length === 0
					? settings.value.providers
					: currentFilters.value.providers;

			const watchnowFilter = {
				packages: watchNowPackages,
				monetizationTypes: currentFilters.value.monetization_types.map((monetizationType: any) =>
					toGQLMonetizationType(monetizationType)
				),
			};
			const getEpisodesFields = {
				episodeNumber: titleToMarkAsSeen?.content.episodeNumber,
				seasonNumber: titleToMarkAsSeen?.content.seasonNumber,
			};

			await setInSeenlist(
				titleToMarkAsSeen?.id,
				isTitleInSeenlist,
				{
					objectType: titleToMarkAsSeen.objectType,
					objectId: titleToMarkAsSeen.objectId,
					title: titleToMarkAsSeen.content.title,
					...getEpisodesFields,
				},
				watchnowFilter,
				{ source: 'TvstSpotlightModule' },
				['GetHomeModules']
			);
		} catch (e) {
			console.error('<TvstSpotlightModule> handleMarkAsSeen', e);
		} finally {
			saving.value = false;
		}
	}
}

/* TRACKING */
const { moduleContext, moduleObserveVisibility, trackHomeModule } = useHomeModuleTracking({
	moduleData: () => props.moduleData,
	globalPosition: () => props.globalPosition,
	localPosition: () => props.localPosition,
	titleSize: () => props.moduleData.titles.length,
});

function trackTitleClicked(...contextData: Parameters<typeof SnowplowTitleContextGraphql.fromTitle>) {
	trackHomeModule('titleClicked', {
		spec: { label: moduleContext.value.type },
		contexts: [SnowplowTitleContextGraphql.fromTitle(...contextData)],
	});
}

return { __sfc: true,props, router, settings, currentFilters, setInSeenlist, saving, showAllUrl, handleMarkAsSeen, moduleContext, moduleObserveVisibility, trackHomeModule, trackTitleClicked, SpotlightModuleWithHorizontalScroll, TitleCardShowEpisode }
}

})